import { render, staticRenderFns } from "./FiltrosLicitacoesFornecedor.vue?vue&type=template&id=a5f243f0&"
import script from "./FiltrosLicitacoesFornecedor.vue?vue&type=script&lang=js&"
export * from "./FiltrosLicitacoesFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports